import { EDITOR_TYPES } from "~/constants/EditorTypes";

/**
 * Determine if the output format toggle should be visible.
 * Requires: HTML-capable editor in html mode AND tier in allowed list.
 *
 * @param {string} editorType - Editor type key from EDITOR_TYPES
 * @param {string} mode - Editor mode ("html" or "text")
 * @param {string} selectedTier - Currently selected model tier
 * @param {Array|undefined} allowedTiers - PostHog feature flag payload (array of tier strings)
 */
const isFormatToggleVisible = (
  editorType,
  mode,
  selectedTier,
  allowedTiers,
) => {
  const isHtmlCapable =
    EDITOR_TYPES[editorType]?.htmlCapable && mode === "html";
  if (!isHtmlCapable) {
    return false;
  }
  if (!Array.isArray(allowedTiers)) {
    return false;
  }
  return allowedTiers.includes(selectedTier);
};

export default isFormatToggleVisible;
